
const Location = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_33_177)">
        <path
          d="M12.0001 6C11.209 6 10.4356 6.2346 9.77781 6.67412C9.12002 7.11365 8.60733 7.73836 8.30458 8.46927C8.00182 9.20017 7.92261 10.0044 8.07695 10.7804C8.23129 11.5563 8.61226 12.269 9.17167 12.8284C9.73108 13.3878 10.4438 13.7688 11.2197 13.9231C11.9957 14.0775 12.7999 13.9983 13.5308 13.6955C14.2617 13.3928 14.8864 12.8801 15.326 12.2223C15.7655 11.5645 16.0001 10.7911 16.0001 10C16.0001 8.93913 15.5787 7.92172 14.8285 7.17157C14.0784 6.42143 13.061 6 12.0001 6ZM12.0001 12C11.6045 12 11.2179 11.8827 10.889 11.6629C10.5601 11.4432 10.3037 11.1308 10.1523 10.7654C10.001 10.3999 9.96135 9.99778 10.0385 9.60982C10.1157 9.22186 10.3062 8.86549 10.5859 8.58579C10.8656 8.30608 11.222 8.1156 11.6099 8.03843C11.9979 7.96126 12.4 8.00087 12.7655 8.15224C13.1309 8.30362 13.4433 8.55996 13.663 8.88886C13.8828 9.21776 14.0001 9.60444 14.0001 10C14.0001 10.5304 13.7894 11.0391 13.4143 11.4142C13.0392 11.7893 12.5305 12 12.0001 12Z"
          fill="white"
        />
        <path
          d="M11.9999 24.0003C11.1579 24.0046 10.327 23.8071 9.57698 23.4243C8.82694 23.0416 8.17951 22.4847 7.68892 21.8003C3.87792 16.5433 1.94492 12.5913 1.94492 10.0533C1.94492 7.38654 3.00428 4.82901 4.88996 2.94333C6.77564 1.05765 9.33316 -0.00170898 11.9999 -0.00170898C14.6667 -0.00170898 17.2242 1.05765 19.1099 2.94333C20.9956 4.82901 22.0549 7.38654 22.0549 10.0533C22.0549 12.5913 20.1219 16.5433 16.3109 21.8003C15.8203 22.4847 15.1729 23.0416 14.4229 23.4243C13.6728 23.8071 12.842 24.0046 11.9999 24.0003ZM11.9999 2.18129C9.91233 2.18367 7.91093 3.01402 6.43479 4.49016C4.95864 5.96631 4.1283 7.96771 4.12592 10.0553C4.12592 12.0653 6.01892 15.7823 9.45492 20.5213C9.74661 20.9231 10.1293 21.2501 10.5716 21.4756C11.014 21.701 11.5034 21.8186 11.9999 21.8186C12.4964 21.8186 12.9859 21.701 13.4282 21.4756C13.8705 21.2501 14.2532 20.9231 14.5449 20.5213C17.9809 15.7823 19.8739 12.0653 19.8739 10.0553C19.8715 7.96771 19.0412 5.96631 17.565 4.49016C16.0889 3.01402 14.0875 2.18367 11.9999 2.18129Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_33_177">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Location;